export const DEFAULT_SALES_SETTINGS = {
    timezone: 'America/Panama',
    planning: {
        planningWeekdays: [5, 6],
        submissionDeadlineWeekday: 6,
        submissionDeadlineTime: '23:59',
        weeksAhead: 1,
        commercialWeekdays: [1, 2, 3, 4, 5, 6],
        adminOverride: true,
        minVisitDurationMinutes: 1,
        maxVisitDurationMinutes: 1439
    },
    location: {
        requireStartLocation: false,
        requireEndLocation: false,
        allowWithoutLocationWithJustification: true,
        accuracyThresholdMeters: 100,
        gpsTimeoutMs: 12000,
        minimumExceptionNoteLength: 3
    },
    execution: {
        enforceSingleActiveVisit: true,
        longRunningVisitMinutes: 180
    },
    reports: {
        lockWeekday: 8,
        lockTime: '00:00',
        maxPhotos: 10,
        maxPhotoBytes: 750 * 1024,
        maxTotalPhotoBytes: 10 * 750 * 1024,
        allowSubmittedEditsUntilLock: true,
        requiredFields: ['summary', 'outcome'],
        followUpRequiredOutcomes: [
            'followUpRequired',
            'quoteRequested',
            'sampleRequested',
            'opportunityIdentified',
            'potentialOrder',
            'complaint'
        ]
    },
    permissions: {}
};

export const mergeSalesSettings = (value = {}) => ({
    ...DEFAULT_SALES_SETTINGS,
    ...value,
    planning: { ...DEFAULT_SALES_SETTINGS.planning, ...(value.planning || {}) },
    location: { ...DEFAULT_SALES_SETTINGS.location, ...(value.location || {}) },
    execution: { ...DEFAULT_SALES_SETTINGS.execution, ...(value.execution || {}) },
    reports: { ...DEFAULT_SALES_SETTINGS.reports, ...(value.reports || {}) },
    permissions: value.permissions || {}
});

export const WEEKDAY_OPTIONS = [
    { label: 'Lunes', value: 1 },
    { label: 'Martes', value: 2 },
    { label: 'Miércoles', value: 3 },
    { label: 'Jueves', value: 4 },
    { label: 'Viernes', value: 5 },
    { label: 'Sábado', value: 6 },
    { label: 'Domingo', value: 7 }
];

export const getWeekdayLabel = (weekday) =>
    WEEKDAY_OPTIONS.find((option) => option.value === Number(weekday))?.label || `Día ${weekday}`;
